import { authorizedApiClient } from "../config";
import type {
  ComputationRun,
  ComputedLabel,
  ComputedLabelCreateRequest,
  ComputedLabelUpdateRequest,
  ComputedMetric,
  ComputedMetricCreateRequest,
  ComputedMetricUpdateRequest,
  RecomputeRequest,
  RecomputeResponse,
  TrackHistoryToggleRequest,
} from "./computedTraitsEndpoints.interface";

export const listComputedMetrics = async ({ workspace_id }: { workspace_id: string }) =>
  authorizedApiClient.get<ComputedMetric[]>(`/${workspace_id}/computed-metrics`);

export const createComputedMetric = async ({
  workspace_id,
  payload,
}: {
  workspace_id: string;
  payload: ComputedMetricCreateRequest;
}) => authorizedApiClient.post<ComputedMetric>(`/${workspace_id}/computed-metrics`, payload);

export const updateComputedMetric = async ({
  workspace_id,
  metric_id,
  payload,
}: {
  workspace_id: string;
  metric_id: string;
  payload: ComputedMetricUpdateRequest;
}) => authorizedApiClient.put<ComputedMetric>(`/${workspace_id}/computed-metrics/${metric_id}`, payload);

export const deleteComputedMetric = async ({
  workspace_id,
  metric_id,
}: {
  workspace_id: string;
  metric_id: string;
}) => authorizedApiClient.delete(`/${workspace_id}/computed-metrics/${metric_id}`);

export const toggleComputedMetricTrackHistory = async ({
  workspace_id,
  metric_id,
  payload,
}: {
  workspace_id: string;
  metric_id: string;
  payload: TrackHistoryToggleRequest;
}) =>
  authorizedApiClient.patch<ComputedMetric>(
    `/${workspace_id}/computed-metrics/${metric_id}/track-history`,
    payload
  );

export const listComputedLabels = async ({ workspace_id }: { workspace_id: string }) =>
  authorizedApiClient.get<ComputedLabel[]>(`/${workspace_id}/computed-labels`);

export const createComputedLabel = async ({
  workspace_id,
  payload,
}: {
  workspace_id: string;
  payload: ComputedLabelCreateRequest;
}) => authorizedApiClient.post<ComputedLabel>(`/${workspace_id}/computed-labels`, payload);

export const updateComputedLabel = async ({
  workspace_id,
  label_id,
  payload,
}: {
  workspace_id: string;
  label_id: string;
  payload: ComputedLabelUpdateRequest;
}) => authorizedApiClient.put<ComputedLabel>(`/${workspace_id}/computed-labels/${label_id}`, payload);

export const deleteComputedLabel = async ({
  workspace_id,
  label_id,
}: {
  workspace_id: string;
  label_id: string;
}) => authorizedApiClient.delete(`/${workspace_id}/computed-labels/${label_id}`);

export const toggleComputedLabelTrackHistory = async ({
  workspace_id,
  label_id,
  payload,
}: {
  workspace_id: string;
  label_id: string;
  payload: TrackHistoryToggleRequest;
}) =>
  authorizedApiClient.patch<ComputedLabel>(
    `/${workspace_id}/computed-labels/${label_id}/track-history`,
    payload
  );

export const triggerComputedTraitsRecompute = async ({
  workspace_id,
  payload,
}: {
  workspace_id: string;
  payload: RecomputeRequest;
}) => authorizedApiClient.post<RecomputeResponse>(`/${workspace_id}/computed-metrics/recompute`, payload);

export const listComputationRuns = async ({
  workspace_id,
  limit = 20,
}: {
  workspace_id: string;
  limit?: number;
}) => authorizedApiClient.get<ComputationRun[]>(`/${workspace_id}/computation-runs?limit=${limit}`);
